import React from 'react'
import './styles.scss'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'

import { logout, userSelector } from '../../../redux/features/user/userSlice'
import { Link } from 'react-router-dom'
import LanguageChanger from '../../Shared/LanguageChanger'

const Header = () => {
  const dispatch = useDispatch()
  const { isLoggedIn } = useSelector(userSelector)
  const { t } = useTranslation()

  const onLogOut = () => {
    dispatch(logout())
  }

  const navLinks =
    <nav className="mygiata_top_navi">
      <ul className="mygiata_top_navi_links">
        <li className={'navigation-item'}><Link to="/create-list">{t('CREATE_LIST')}</Link></li>
        <li className={'navigation-item'}><Link to="/view-lists">{t('VIEW_LISTS')}</Link></li>
        <li className={'navigation-item'}><span className={'Link'} onClick={onLogOut}>{t('LOGOUT')}</span></li>
        <li className={'navigation-item'}><LanguageChanger/></li>
      </ul>
    </nav>

  return (
    <header className="mygiata_header">
      <div className="mygiata_header_top">
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <div style={{ display: 'flex', flex: 1 }}>
            <Link to="/" className="mygiata_logo">
              <span className={'mygiata_logo_text'}>{t('SERVICE_NAME')}</span>
            </Link>
          </div>
          {isLoggedIn
            ? <div style={{ display: 'flex', flex: 1, justifyContent: 'flex-end' }}>
              {navLinks}
            </div>
            : <div style={{ display: 'flex', flex: 1, justifyContent: 'flex-end' }}>
              <nav className="mygiata_top_navi">
                <ul className="mygiata_top_navi_links">
                  <li className={'navigation-item'}><LanguageChanger/></li>
                </ul>
              </nav>
            </div>}
        </div>
      </div>
    </header>
  )
}

export default Header
